import createAPIServices from './createAPIServices'
import { baseUrlPhotoCloud } from './createAPIServices'
const api = createAPIServices()

// api phần orgnization
export const getListOrgAPI = (status_del = 0) => {
    return api.makeAuthRequest({
        url: `/organizations?status_del=${status_del}`,
        method: 'GET',
    })
}

export const getListOrgNotCheckAPI = (status_del = 0) => {
    return api.makeAuthRequest({
        url: `/organizations/notcheck?status_del=${status_del}`,
        method: 'GET',
    })
}

export const createNewOrgAPI = orgnization => {
    const json = JSON.stringify(orgnization)
    return api.makeAuthRequest({
        url: `/organizations`,
        method: 'POST',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const addNewOrgAPI = orgnization => {
    const json = JSON.stringify(orgnization)
    return api.makeAuthRequest({
        url: `/organizations`,
        method: 'POST',
        data: json,
        header: {
            'Content-Type': 'application/json',
        },
    })
}

export const getOrgByOidAPI = oid => {
    return api.makeAuthRequest({
        url: `/organizations/${oid}`,
        method: 'GET',
    })
}

export const getListUser = uids => {
    return api.makeAuthRequest({
        url: `/users/query/list?uids=${uids}`,
        method: 'GET',
    })
}

export const updateOrgByOidAPI = (oid, organi) => {
    const json = JSON.stringify(organi)

    return api.makeAuthRequest({
        url: `/organizations/${oid}`,
        method: 'PUT',
        data: json,
    })
}

export const deleteOrgByOidAPI = oid => {
    return api.makeAuthRequest({
        url: `/organizations/${oid}`,
        method: 'DELETE',
    })
}

export const searchUserAPI = (page_number, page_size, keyword) => {
    return api.makeAuthRequest({
        url: `/search/users?page_number=${page_number}&page_size=${page_size}&text=${keyword}&status=${1}`,
        method: 'GET',
    })
}

export const getListOrgQueryById = lst => {
    return api.makeAuthRequest({
        url: `/organizations/query/list?ids=${lst}`,
        method: 'GET',
    })
}

export const uploadAvatar = image => {
    const formData = new FormData()
    formData.append('files', image)

    const uploadAPI = createAPIServices({
        BaseURL: baseUrlPhotoCloud,
    })

    return uploadAPI.makeRequest({
        // url: '/upload',
        method: 'POST',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}
